export const catalog_matrix = [
  {form_key:'benefit_status_id', catalog_key:'benefit_statuses'},
  //{form_key:'benefit_id', catalog_key:'benefits'},
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]